module.exports = __webpack_public_path__ + "static/technical-ly-logo-f95b8f0dfbd73f41bb0ebf4672d4aa38.png";